export const makePromoBannerPolicy = () => ({
  keyFields: ['placeId'],
});

export const promoBannerPolicies = {
  BillboardBanner: makePromoBannerPolicy(),
  DoubleBanner: makePromoBannerPolicy(),
  FeaturetteBanner: makePromoBannerPolicy(),
  LeaderboardBanner: makePromoBannerPolicy(),
  MarqueeBanner: makePromoBannerPolicy(),
  MerchandisingBanner: makePromoBannerPolicy(),
};
